import { useEffect, useState } from "react";
import { PulseIcon } from "@phosphor-icons/react";
import { fetchHealthLimits } from "@/lib/api";

const DOT = {
  ok: "bg-neon shadow-[0_0_6px_rgba(0,255,136,0.7)]",
  degraded: "bg-amber-400 shadow-[0_0_6px_rgba(251,191,36,0.6)]",
  down: "bg-red-500 shadow-[0_0_6px_rgba(239,68,68,0.6)]",
};
const TXT = { ok: "text-muted-foreground", degraded: "text-amber-400", down: "text-red-400" };

const ServicePill = ({ s }) => (
  <div
    data-testid={`health-pill-${s.id}`}
    title={s.affects?.length ? `${s.note} · Paused: ${s.affects.join(", ")}` : s.note}
    className="flex items-center gap-1.5 px-2 py-0.5 border border-white/10 bg-white/[0.03] whitespace-nowrap"
  >
    <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${DOT[s.status] || DOT.down}`} />
    <span className="text-[10px] sm:text-[11px] font-mono uppercase tracking-wide text-muted-foreground">{s.label}</span>
    <span className={`text-[10px] font-mono ${TXT[s.status] || TXT.down}`}>
      {s.status === "ok" ? "live" : s.note}
    </span>
  </div>
);

export const ApiHealthMeter = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () => fetchHealthLimits().then((d) => alive && setData(d)).catch(() => {});
    load();
    const id = setInterval(load, 60000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  if (!data) return null;
  const allOk = data.overall === "ok";

  return (
    <div data-testid="api-health-meter" className="bg-black/90 backdrop-blur-xl border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-1.5 flex items-center gap-2 sm:gap-3">
        <span className="flex items-center gap-1.5 text-[10px] sm:text-[11px] font-mono uppercase tracking-wide text-muted-foreground shrink-0">
          <PulseIcon size={13} weight="bold" className={allOk ? "text-neon" : "text-amber-400"} />
          <span className="hidden sm:inline">Data feeds</span>
        </span>
        <div className="flex items-center gap-1.5 sm:gap-2 flex-1 min-w-0 overflow-x-auto no-scrollbar">
          {data.services.map((s) => <ServicePill key={s.id} s={s} />)}
        </div>
      </div>
    </div>
  );
};
